//export const apiUrl = "http://151.80.254.225:8083/";
export const apiUrl = "https://api.prise-suivi.tg/";
//export const apiUrl = "http://localhost:8083/";
